import { render, staticRenderFns } from "./ArrivalConfirm.vue?vue&type=template&id=3890025b&scoped=true&"
import script from "./ArrivalConfirm.vue?vue&type=script&lang=js&"
export * from "./ArrivalConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ArrivalConfirm.vue?vue&type=style&index=0&id=3890025b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3890025b",
  null
  
)

export default component.exports